import {
	EditCustomerContext,
	IEditCustomerContext,
} from 'modules/CustomersAndRestaurants/Customers/EditCustomer/editCustomerState/editCustomerContext';
import React, { useContext } from 'react';
import InputFields from './components/InputFields/InputFields';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import BtnBlock from './components/InputFields/components/BtnBlock';
import NoData from 'components/NoResultsFound/NoData';
import ModalWindows from './components/ModalWindows/ModalWindows';
import { ILocalizationContext, LocalizationContext } from '../../localizationState/localizationContext';
import { ICustomerLocalizationGroup } from 'types';
import style from './EditMode.module.scss';

const EditMode: React.FC = () => {
	const { addInvalidField, clearInvalidFields, changeTypeOfModalWindow, setDataForSubmit, selectedLanguage, groups } =
		useContext<ILocalizationContext>(LocalizationContext);
	const { customerLanguages } = useContext<IEditCustomerContext>(EditCustomerContext);

	const params = new URL(document.location.href).searchParams;
	const customerID = params.get('customerID');

	const submit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		clearInvalidFields();
		const formData = new FormData(e.target as HTMLFormElement);
		const formValues = Object.fromEntries(formData) as { [key: string]: string };
		let isAllowToSubmit = true;

		let finalGroups: ICustomerLocalizationGroup[] = groups;

		for (const formValuesKey in formValues) {
			const [groupId, itemKey, translationId, isRequired] = formValuesKey.split('/');
			if (!formValues[formValuesKey] && isRequired === 'true') {
				addInvalidField(formValuesKey);
				isAllowToSubmit = false;
			}
			finalGroups = finalGroups.map((group) =>
				group.id === groupId
					? {
							...group,
							items: group.items.map((item) =>
								item.key === itemKey
									? {
											...item,
											translations: item.translations.map((trans) =>
												trans.languageId === translationId
													? { ...trans, value: formValues[formValuesKey] }
													: trans,
											),
									  }
									: item,
							),
					  }
					: group,
			);
		}

		if (customerID && isAllowToSubmit) {
			setDataForSubmit({
				ownerId: customerID,
				groups: finalGroups,
			});
			changeTypeOfModalWindow('toConfirmSubmit');
		}
	};

	return (
		<div className={style.container} data-test="EditMode">
			{groups.length ? (
				<>
					<div className={style.sidebar}>
						<Sidebar items={groups} />
					</div>
					<div className={style.content}>
						<div className={style.controls}>
							<LanguageBar items={customerLanguages} />
						</div>
						<form className={style.form} name="localization" onSubmit={submit}>
							{customerLanguages.map((el) => (
								<InputFields
									key={el.languageId}
									languageId={el.languageId}
									isVisible={selectedLanguage?.id === el.languageId}
								/>
							))}
							<BtnBlock />
						</form>
					</div>
				</>
			) : (
				<NoData />
			)}
			<ModalWindows />
		</div>
	);
};

export default EditMode;
